import { Dispatch, SetStateAction, useState } from "react";
import { Accessor, PropertyAttribute } from "../types/types";

export interface UseSelectedColumns {
	selectedAccessors: Accessor[];
	setSelectedAccessors: Dispatch<SetStateAction<Accessor[]>>;
	selectedPropertyAttributes: PropertyAttribute[];
	setSelectedPropertyAttributes: Dispatch<SetStateAction<PropertyAttribute[]>>;
}

/**
 * Displayed accessors if none have been selected or pulled from state. This matches the columns and ordering of
 * the legacy data tables.
 * */
const defaultSelectedAccessors: Accessor[] = [
	"location.addr_no",
	"location.addr_street",
	"location.addr_city",
	"location.postcode",
	"metrics.epc_rating",
	"metrics.epc_rating_grade",
	"sap_data.improved_to_cbr_sap_value",
	"data_integrity.value",
	"sap_data.current_heat_demand",
	"sap_data.potential_heat_demand",
	"building.construction_age",
	"building.detachment",
	"building.property_type",
	"metrics.odc_lodgement_date",
	"heating.heating_type",
	"heating.controls",
	"water.water_source",
	"building.floor_construction",
	"building.wall_type",
	"building.wall_construction",
	"windows.glazing_type",
	"windows.glazing_u_value",
	"roof.roof_type",
	"roof.roof_construction",
	"heating.fuel_type",
];

const defaultSelectedPropertyAttributes: PropertyAttribute[] = ["uprn", "sap_version", "sap_is_rdsap"];

export default function useSelectedColumns(): UseSelectedColumns {
	const [selectedAccessors, setSelectedAccessors] = useState<Accessor[]>(defaultSelectedAccessors);
	const [selectedPropertyAttributes, setSelectedPropertyAttributes] = useState<PropertyAttribute[]>(
		defaultSelectedPropertyAttributes
	);

	return {
		selectedAccessors,
		setSelectedAccessors,
		selectedPropertyAttributes,
		setSelectedPropertyAttributes,
	};
}
